import { Card, CardBody, Flex } from '@chakra-ui/react';
import React from 'react';

import {
  UserTooltip,
  UserDetail,
} from 'packages/common-frontend/components/UserDetail';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import {
  mockBorrowerUserAuthContext,
  mockCapitalProviderUserAuthContext,
} from '~/contexts/UserAuthProvider/__tests__/commonUserMocks';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Typography } from '~/packages/common-frontend/components/Typography';

// Constants
const COMPONENT_NAME = './common-frontend/UserDetail';

// Fragments
const RouteBase = () => (
  <PageTemplate title={COMPONENT_NAME}>
    <ComponentGridRenderer
      primaries={['avatar-name', 'name', 'avatar'] as const}
      primaryPropName="variant"
      secondaries={[null]}
      tertiaries={[null]}
      width="30rem"
    >
      {({ primary: variant }) => {
        return (
          <Flex direction="column" flexGrow={1} gap="0.5rem">
            <Typography TextProps={{ gap: '1rem' }}>
              <UserDetail
                variant={variant}
                user={mockBorrowerUserAuthContext.user}
              />
              {' - '}
              <UserDetail
                variant={variant}
                user={mockCapitalProviderUserAuthContext.user}
              />
            </Typography>
            <UserTooltip user={mockBorrowerUserAuthContext.user}>
              <Card size="sm">
                <CardBody>
                  Custom UI with user tooltip:
                  <br />
                  {mockBorrowerUserAuthContext.user.email}
                </CardBody>
              </Card>
            </UserTooltip>
          </Flex>
        );
      }}
    </ComponentGridRenderer>
  </PageTemplate>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
